import React from 'react';
import { Helmet } from 'react-helmet';
import { Layout as AntdLayout } from 'antd';
import { isObject } from 'underscore';
import Breadcrumb from '../Breadcrumb';
import Header from '../Header';
import Sidebar from '../Sidebar';
import icon from '../../../assets/favicon.ico';
import CompanyCurrentAlertBanner from '../../CompanyCurrentAlertBanner';
import Spinner from '../../Spinner';
import { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './layout.css';

const { APP_NAME } = require('../../../core/constants').default;

/**
 * Defines a common global layout for the application.
 * It includes a header, a sidebar (if applicable), Helmet for SEO, Antd Layout for structure, and a spinner for loading states.
 */
class Layout extends Component {
    render() {
        const {
            children, title, toolbar, breadcrumb, className, menu, backLink,
            isVisibleHeader, beforeHeader, afterHeader, floatingHeader, headerTitle,
            menuPlacement, menuWidth, user, loading, companies, overrideUseSidebarStyle,
        } = this.props;

        const useSidebar = isVisibleHeader && (user?.userCompany?.features?.find(feature => feature.id === 'sidebar-nav'));

        return (
            <>
                {user.isLoggedIn && user?.userCompany?.current_alert && (
                    <CompanyCurrentAlertBanner alert={user?.userCompany?.current_alert} />
                )}
                <div className={`page-wrap ${className} ${user?.userCompany?.current_alert && 'with-banner'}`}>
                    <Helmet
                        title={!isObject(title) ? (title.charAt(0).toUpperCase() + title.slice(1)) : title.props.children}
                        titleTemplate={`%s - ${APP_NAME}`}
                        defaultTitle={`${APP_NAME}`}
                        meta={[{ 
                            name: 'description', 
                            content: `${APP_NAME} website`,
                        }, { 
                            property: 'og:type', 
                            content: 'website',
                        }]}
                    >
                        <link 
                            rel="shortcut icon" 
                            href={icon} 
                        />
                    </Helmet>
                    {isVisibleHeader && !useSidebar ? (
                        <Header
                            beforeheader={beforeHeader}
                            afterHeader={afterHeader}
                            floating={floatingHeader}
                            title={headerTitle || title}
                            toolbar={toolbar}
                            backLink={backLink}
                            menu={menu}
                            menuPlacement={menuPlacement}
                            menuWidth={menuWidth} 
                        />
                    ) : null}   
                    {useSidebar && (
                        <Sidebar
                            toggleSidebar={this.toggleSidebar}
                            companies={companies}
                            user={user}
                        >
                        </Sidebar>
                    )}
                    <AntdLayout.Content className={`main-content ${useSidebar || overrideUseSidebarStyle ? 'sidebar-view' : ''}`}>
                        <Spinner loading={loading}>
                            {breadcrumb ? <Breadcrumb navigation={breadcrumb} /> : null}
                            {children}
                        </Spinner>
                    </AntdLayout.Content>
                </div>
            </>
        );
    }
}

Layout.defaultProps = {
    breadcrumb: null,
    toolbar: [],
    className: "",
    isVisibleHeader: true,
    beforeHeader: null,
    afterHeader: null,
    floatingHeader: false,
    headerTitle: null,
    menu: [],
    backLink: null,
    logo: null,
    menuPlacement: "left",
    menuWidth: 280
};

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    breadcrumb: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    title: PropTypes.node.isRequired,
    toolbar: PropTypes.array,
    className: PropTypes.string,
    isVisibleHeader: PropTypes.bool,
    beforeHeader: PropTypes.object,
    afterHeader: PropTypes.object,
    floatingHeader: PropTypes.bool,
    headerTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    menu: PropTypes.array,
    backLink: PropTypes.object,
    logo: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    menuPlacement: PropTypes.string,
    menuWidth: PropTypes.number
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        user: state.user,
        companies: state.company.companies,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({}, dispatch) };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Layout);
